import { ConfirmOTPRequest } from '../api/otp/confirmotp/confirmotprequest';
import { ConfirmOTPResponse, ConfirmOTPResponseDtoImpl } from '../api/otp/confirmotp/confirmotpresponse';
import { APIFeatures } from '../util/apifeatures';
import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';
/* import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { OTPCheckBuilder } from '../dto/otp/otpcheck/otpcheckbuilder';
import { StatusCodes } from '../util/statuscodes'; */

export class ConfirmOtpAPIProcessorImpl extends APIProcessorImpl<ConfirmOTPRequest, ConfirmOTPResponse>
{
    //  execute()
    //  {
    //      console.log("execute() in GenerateOTPAPIProcessorImpl"); 

    //      let response = new ConfirmOTPResponseDtoImpl(APIFeatures.CONFIRM_OTP, "");

    //                 this.getAPISuccess(response);
    //  } 

    onSuccess(responseMapper: ResponseMapper): void 
    {
        try{
            
            if(+responseMapper.getStatusCode() === StatusCodes.SUCCESS)
            {
                if(responseMapper.getStatusCodeOutside() === "SC0000" ||
                responseMapper.getResponseMap().respCode === "000" 
                            || responseMapper.getResponseMap().respCode === "SC0000")
                {
                    let response = new ConfirmOTPResponseDtoImpl(APIFeatures.CONFIRM_OTP, "");

                    this.getAPISuccess(response);
                }
                else if(responseMapper.getResponseMap().respCode === "100")
                {//non-registered etisalath
                    let subscriberValidationResponse = new ConfirmOTPResponseDtoImpl(
                    APIFeatures.CONFIRM_OTP, this.getContext().getResources().getString(Strings.subscriber_not_registered));
    
                    this.getAPIFailure(subscriberValidationResponse);
                }
                else if(responseMapper.getResponseMap().respCode === "002")
                {//password expired/ blocked by admin
                    let subscriberValidationResponse = new ConfirmOTPResponseDtoImpl(
                    APIFeatures.CONFIRM_OTP, this.getContext().getResources().getString(Strings.password_blocked));
    
                    this.getAPIFailure(subscriberValidationResponse);
                }
                else
                {
                    //not -registered, not-etisalath
                    let subscriberValidationResponse = new ConfirmOTPResponseDtoImpl(
                        APIFeatures.CONFIRM_OTP, this.getContext().getResources().getString(Strings.invalid_mpt_subscriber));
        
                        this.getAPIFailure(subscriberValidationResponse);
                }
            }
             else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new ConfirmOTPResponseDtoImpl(APIFeatures.CONFIRM_OTP, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new ConfirmOTPResponseDtoImpl(APIFeatures.CONFIRM_OTP, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch(e)
        {
            this.getAPIFailure(new ConfirmOTPResponseDtoImpl(APIFeatures.CONFIRM_OTP, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }
    
    onFailure(responseMapper: ResponseMapper): void 
    { 
    this.getAPIFailure(new ConfirmOTPResponseDtoImpl(APIFeatures.CONFIRM_OTP, responseMapper.getStatusMsg()));
    
    }  
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/confirmotpprocessor.tsx